var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconComleted = function SvgIconComleted(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 18,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon-comleted_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#20B26C",
    fillRule: "evenodd",
    d: "M2.75 9a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0M9.5.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5m3.912 6.899A.75.75 0 1 0 12.338 6.6l-3.87 3.97-1.826-1.74a.75.75 0 1 0-1.034 1.087l2.357 2.245c.3.286.775.277 1.065-.02z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-comleted_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h18v18H.5z"
  })))));
};
export default SvgIconComleted;